import { render, staticRenderFns } from "./main-expand-button.vue?vue&type=template&id=01573d68&scoped=true"
import script from "./main-expand-button.vue?vue&type=script&lang=js"
export * from "./main-expand-button.vue?vue&type=script&lang=js"
import style0 from "./main-expand-button.vue?vue&type=style&index=0&id=01573d68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01573d68",
  null
  
)

export default component.exports